/**
 * Move element after another referenced element in the DOM
 *
 * @param {HTMLElement} el The element to be moved.
 * @param {HTMLElement} referenceNode The node that will be referenced for the new position.
 */
const insertAfter = (el, referenceNode) => {
  referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
};

export default insertAfter;
